export default __webpack_public_path__ + "static/media/37.65f3b59c.gif";